<template>
    <div class="d-flex align-items-center justify-content-center ag-overall">
        <div class="w-50">
            <ag-loading v-if="loading" />
            <div v-if="!loading" class="text-center mt-5">
                <div>
                    <h4 class="title mb-1">{{ $t("group") }}</h4>
                    <p>{{ this.groupName }}</p>
                </div>
                <div>
                    <h4 class="title mb-1">{{ $t("policyName") }}</h4>
                    <p> {{ policy.policyName || $t("N/A") }} <strong class="mx-3">/</strong> {{ policy.folderName !== "" ? policy.folderName : selectedRow.ruleName }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { useStore } from "@/store";
import AgLoading from "@/components/ag-loading/index.vue";
import api from "@/api/index";
import { notify } from "@kyvg/vue3-notification";
import { GeneralActionTypes } from "@/store/modules/general/action-types";

const store = useStore();

export default {
    name: "ag-event-policy",
    components: { AgLoading, },
    props: {
        data: {
            type: Array,
            default: null,
        },
        options: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            groupName: null,
            policy: null,
            loading: false,
        }
    },
    async created() {
        this.loading = true;
        try {
            const res = await api.groups.getById(this.selectedRow.groupGuid);
            if (res.data.entityData && res.data.statusCode === 200) {
                this.groupName = res.data.entityData.name;
                this.policy = await store.dispatch(GeneralActionTypes.GET_EVENT_POLICY_NAME, {
                    mainId: res.data.entityData.mainId,
                    ruleId: this.selectedRow.ruleId,
                    ruleSource: this.selectedRow.ruleSource
                });
                this.loading = false
            } else {
                notify({
                    title: this.$t('errorOccurred'),
                    text: res.data.message,
                    type: "error",
                    duration: 8000,
                });
            }
        } catch (error) {
            console.error('Error:', error);
        } finally {
            this.loading = false;
        }
    },
    computed: {
        selectedRow() {
            return store.state.general.selectedExpandedRow;
        },
    },
    watch: {
        selectedRow(newItem, oldItem) {
            setTimeout(() => {
                this.getList();
            }, 100);
        },
    },
    methods: {

    }
};
</script>

<style>
.ag-overall {
    padding: 20px 0px;

    h2 {
        color: #5e5e5e;
    }

    h4 {
        font-weight: 300;
    }

    .title {
        color: #5e5e5e;
        font-weight: 700;
    }
}
</style>